import React from 'react';
import { naira } from './data';
import { th } from './helpers';

const CustomReportOverview = ({ overview }) => {
      return (
            <div className="flex-wrap text-center row">
                  {
                        overview?.map(({ amount, title, color, isNumber }, i) =>
                              <div className="mb-4 col" key={i}>
                                    <p className="m-0 grey-text">
                                          {isNumber && naira}{th(amount)}
                                    </p>
                                    <p className="mt-2" style={{ fontSize: '14px', color: color }}>
                                          {title}
                                    </p>
                              </div>
                        )
                  }
            </div>
      );
};

export default CustomReportOverview;